export default "__VITE_ASSET__Dv2vW$bg__"